var BFFGatewayConfiguration = /** @class */ (function () {
    function BFFGatewayConfiguration(param) {
        this.accessToken = param.accessToken;
        this.locale = param.locale;
        this.basePath = param.basePath;
    }
    return BFFGatewayConfiguration;
}());
export { BFFGatewayConfiguration };
//# sourceMappingURL=BFFGatewayConfiguration.js.map